const skills = {
    1: [
        {
            title: "HTML",
            level: 6,
        },
        {
            title: "CSS",
            level: 5,
        },
        {
            title: "JavaScript",
            level: 4,
        },
        {
            title: "TypeScript",
            level: 4,
        },
        {
            title: "ReactJS",
            level: 4,
        },
        {
            title: "Figma",
            level: 5,
        }
    ],
    2: [
        {
            title: "Python",
            level: 5,
        },
        {
            title: "Django",
            level: 3,
        },
        {
            title: "SQL",
            level: 4,
        },
        {
            title: "Firebase",
            level: 3,
        },
        {
            title: "MongoDB",
            level: 2,
        },
        {
            title: "Git",
            level: 5,
        },
    ],
};

export default skills;